import { useCallback, useContext, useEffect, useState } from 'react';
import CloudFunctionClientContext from '../contexts/CloudFunctionClientContext';

const useCommitments = () => {
  const { api } = useContext(CloudFunctionClientContext);
  const [commitments, setCommitments] = useState<Commitment[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (process.env.NODE_ENV === 'test') {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    api
      .get<{ commitments: Commitment[] }>('/v1/commitments/get_all_commitments')
      .then((response) => {
        if (response.ok && response.data) {
          setCommitments(response.data.commitments);
        } else {
          setCommitments([]);
        }
        setIsLoading(false);
      });
  }, [api]);

  const refreshCommitments = useCallback(() => {
    setIsLoading(true);
    setCommitments([]);
    api
      .get<{ commitments: Commitment[] }>('/v1/commitments/get_all_commitments')
      .then((response) => {
        if (response.ok && response.data) {
          setCommitments(response.data.commitments);
        } else {
          setCommitments([]);
        }
        setIsLoading(false);
      });
  }, [api]);

  return {
    commitments,
    isLoading,
    refreshCommitments,
  };
};

export default useCommitments;
